"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const core_1 = require("@material-ui/core");
const cloneDeep_1 = __importDefault(require("lodash/cloneDeep"));
const isEqual_1 = __importDefault(require("lodash/isEqual"));
require("./app.scss");
const searchbar_1 = __importDefault(require("../../shared/components/searchbar/searchbar"));
const stripe_1 = __importDefault(require("./components/stripe/stripe"));
const item_case_1 = __importDefault(require("./components/item-case/item-case"));
const ajaxLoader_1 = __importDefault(require("../../shared/components/ajaxLoader/ajaxLoader"));
const config_1 = require("./utils/config");
const svgIcons_1 = require("../../svgIcons");
const userHistorySlice_1 = require("../../redux/slices/userHistorySlice");
const pagination_1 = __importDefault(require("../../shared/components/pagination/pagination"));
const common_1 = require("../../utils/common");
const noResult_1 = __importDefault(require("../../shared/components/noResult/noResult"));
const irs_form_1 = __importDefault(require("./components/irs-form/irs-form"));
const rangePicker_1 = __importDefault(require("./components/range-picker/rangePicker"));
const caseDetails_1 = __importDefault(require("./modals/caseDetails/caseDetails"));
const filterBlock_1 = __importDefault(require("../../shared/layouts/filterBlock/filterBlock"));
const checkboxList_1 = __importDefault(require("./components/checkboxList/checkboxList"));
const radioButtonsList_1 = __importDefault(require("./components/radioButtonsList/radioButtonsList"));
const noResult_2 = __importDefault(require("../../shared/components/noSearchResult/noResult"));
class App extends react_1.Component {
    constructor() {
        super(...arguments);
        this.state = {
            modalOpen: false,
            showIrsCompletePopup: false,
            filterOpen: false,
            showIcon: true,
            checkData: false,
            firstData: true
        };
        // ios mobile height fixer
        this.fixIOSHeight = () => {
            const pageWrapper = document.getElementById("page_wrapper");
            const mobileFooterHeight = 88;
            const calcHeight = (pageWrapper.offsetHeight - mobileFooterHeight);
            pageWrapper.style.height = `${calcHeight}px`;
        };
        this.removeFixedHeight = () => {
            const pageWrapper = document.getElementById("page_wrapper");
            pageWrapper.style.height = null;
        };
        // open or close item details modal
        this.handleModalChange = () => {
            this.props.toggleDetailsModal();
        };
        // search field filter
        this.handleInputSearch = (value) => {
            this.state.showIcon = value !== '' ? false : true;
            common_1.ifMobile() || common_1.isMobileBrowser() ? this.scrollToListTop() : '';
            const { filter } = this.props.userHistory;
            const updatedFilter = cloneDeep_1.default(Object.assign(Object.assign({}, filter), { offset: parseInt(common_1.urlPrams("page")) - 1 || 0, q: value }));
            this.props.updateHistoryList(updatedFilter);
        };
        // filter by request_was properties
        this.handleFilterClick = (e, value) => {
            common_1.ifMobile() || common_1.isMobileBrowser() ? this.scrollToListTop() : '';
            const { filter } = this.props.userHistory;
            const updatedFilter = cloneDeep_1.default(Object.assign(Object.assign({}, filter), { offset: parseInt(common_1.urlPrams("page")) - 1 || 0, request_was: value }));
            this.props.updateHistoryList(updatedFilter);
        };
        // filter by request_type
        this.handleFilterChange = (e, filterType, updatedFilter, selected) => {
            common_1.ifMobile() || common_1.isMobileBrowser() ? this.scrollToListTop() : '';
            if (e.target.checked) {
                updatedFilter[filterType].push(e.target.value);
            }
            else {
                updatedFilter[filterType] = updatedFilter[filterType].filter(value => value !== e.target.value);
            }
            this.props.updateHistoryList(updatedFilter);
            e.preventDefault();
        };
        // filter by payment_statuses
        this.handleRadioListChange = (value, filterType) => {
            common_1.ifMobile() || common_1.isMobileBrowser() ? this.scrollToListTop() : '';
            const updatedFilter = cloneDeep_1.default(Object.assign(Object.assign({}, this.props.userHistory.filter), { offset: 0 }));
            if (value === updatedFilter[filterType][0]) {
                updatedFilter[filterType] = [];
            }
            else {
                updatedFilter[filterType].splice(0, 1, value);
            }
            this.props.updateHistoryList(updatedFilter);
        };
        // filter by date range
        this.handleRangeChange = (data) => {
            this.setState({ showIcon: data !== '' ? false : true });
            common_1.ifMobile() || common_1.isMobileBrowser().check ? this.scrollToListTop() : '';
            const { filter } = this.props.userHistory;
            const updatedFilter = cloneDeep_1.default(Object.assign(Object.assign({}, filter), { offset: parseInt(common_1.urlPrams("page")) - 1 || 0, date_from: data.from, date_to: data.to }));
            this.props.updateHistoryList(updatedFilter);
        };
        // show or hide mobile filter
        this.toggleMobileFilter = () => {
            const body = document.body;
            if (common_1.isMobileBrowser().check || common_1.ifMobile()) {
                if (!this.state.filterOpen === true) {
                    this.changeDirectoryFilterPosition();
                }
                else if (!this.state.filterOpen === false) {
                    this.putBackDirectoryFilter();
                }
            }
            this.setState({ filterOpen: !this.state.filterOpen }, () => {
                if (this.state.filterOpen) {
                    body.style.overflowY = 'hidden';
                }
                else {
                    body.style.overflowY = 'auto';
                }
            });
        };
        // ios mobile header position fixer
        this.changeMobileHeaderPosition = () => {
            const mainPageWrapper = document.getElementById("main-page-wrapper");
            const mobileHeader = document.getElementById('payment-history-mob-header');
            const rootWrapper = document.getElementById('root');
            if (mobileHeader && mainPageWrapper) {
                rootWrapper.insertBefore(mobileHeader, mainPageWrapper);
                const calculate = () => {
                    if (common_1.ifMobile()) {
                        mobileHeader.style.zIndex = '749';
                    }
                    const top = window.scrollY;
                    const elem = document.getElementById('payment-history-search-input');
                    const isFocused = (document.activeElement === elem);
                    if (isFocused && top > 0) {
                        mobileHeader.style.top = '0px';
                    }
                    else {
                        mobileHeader.style.top = '50px';
                    }
                };
                document.addEventListener('scroll', (e) => {
                    calculate();
                });
                mobileHeader.addEventListener('click', () => {
                    calculate();
                });
            }
        };
        this.revertMobileHeaderPosition = () => {
            const container = document.getElementById('experts-container');
            const mobileHeader = document.getElementById('payment-history-mob-header');
            if (mobileHeader && container) {
                mobileHeader.style.position = null;
                mobileHeader.style.zIndex = null;
                container.appendChild(mobileHeader);
            }
            else if (mobileHeader) {
                mobileHeader.remove();
            }
            document.removeEventListener('scroll', () => void (1), false);
            mobileHeader.removeEventListener('click', () => void (1), false);
        };
        this.changeDirectoryFilterPosition = () => {
            const tmpFilterWrapper = document.createElement("div");
            tmpFilterWrapper.classList.add("content-wrapper");
            tmpFilterWrapper.id = 'user-history-temp-filter';
            const filterContent = document.getElementById("filter-container");
            tmpFilterWrapper.appendChild(filterContent);
            const mainPageWrapper = document.getElementById("main-page-wrapper");
            const rootWrapper = document.getElementById('root');
            rootWrapper.insertBefore(tmpFilterWrapper, mainPageWrapper);
        };
        this.putBackDirectoryFilter = () => {
            const filterContent = document.getElementById("filter-container");
            const directorySearchBlock = document.getElementById("user-history-content-wrapper");
            directorySearchBlock.appendChild(filterContent);
            const tmpFilterWrapper = document.getElementById("user-history-temp-filter");
            tmpFilterWrapper === null || tmpFilterWrapper === void 0 ? void 0 : tmpFilterWrapper.remove();
        };
        // scroll to filtered list top
        this.scrollToListTop = () => {
            const parentElement = document.getElementById('data-container');
            window.scrollTo(0, parentElement.offsetTop);
        };
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        if (!isEqual_1.default(this.props.userHistory.filter, prevProps.userHistory.filter)) {
            localStorage.removeItem('prevPath');
        }
        if (prevProps.userHistory.list.length >= 1) {
            this.state.firstData && this.setState({ firstData: false });
        }
    }
    componentDidMount() {
        if (common_1.ifMobile() || common_1.isMobileBrowser().check) {
            this.changeMobileHeaderPosition();
            window.AppearMe.Widgets.Events.subscribe('onHistoryBackAction', (e) => {
                var _a;
                (_a = document.getElementById('user-history-temp-filter')) === null || _a === void 0 ? void 0 : _a.remove();
            });
        }
        if (!common_1.ifMobile() && (common_1.isMobileBrowser().check && common_1.isMobileBrowser().ios)) {
        }
        const { showIrsCompletePopup } = this.props.options;
        if (showIrsCompletePopup) {
            this.setState({ showIrsCompletePopup: showIrsCompletePopup });
        }
        this.props.getUserHistory(this.props.userHistory.filter);
        window.AppearMe.Widgets.Events.subscribe('showIrsCompletePopup', (e) => {
            this.setState({ showIrsCompletePopup: e.detail });
        });
        window.AppearMe.Widgets.Events.subscribe('onHistoryEnterAction', (e) => {
            localStorage.setItem('prevPath', e.detail.prevPath);
        });
    }
    componentWillUnmount() {
        if (common_1.ifMobile() || common_1.isMobileBrowser().check) {
            this.revertMobileHeaderPosition();
        }
    }
    render() {
        const { list, filter, itemsCount, totalPaid, totalEarned, mounted, caseDetails, filterReseted } = this.props.userHistory;
        const showCardForm = common_1.urlPrams("showCardForm");
        const { showIrsCompletePopup, showIcon, firstData } = this.state;
        return (react_1.default.createElement(react_1.Fragment, null,
            react_1.default.createElement(core_1.Hidden, { smDown: true },
                react_1.default.createElement("h3", { className: 'page-title' }, "Payment History")),
            react_1.default.createElement("div", { id: "user-history", className: `${itemsCount || !firstData ? '' : 'user-history-empty'}` },
                react_1.default.createElement("div", { id: 'payment-history-mob-header', className: `${itemsCount || !firstData ? 'mobile-header' : 'mobile-header-empty'}` },
                    react_1.default.createElement("h4", { className: 'tab-titles' }, "Payment History"),
                    itemsCount || !firstData ?
                        react_1.default.createElement(searchbar_1.default, { handleInputChange: this.handleInputSearch, className: 'mb-30', style: { top: '10px' } }) : null,
                    react_1.default.createElement("div", { className: "mobile-switch", onClick: this.toggleMobileFilter },
                        react_1.default.createElement(svgIcons_1.ExpandIcon, null),
                        react_1.default.createElement("span", null, "Filter"))),
                showIrsCompletePopup && react_1.default.createElement(irs_form_1.default, null),
                react_1.default.createElement(stripe_1.default, { showCardForm: !!showCardForm }),
                itemsCount || !firstData ? react_1.default.createElement(core_1.Hidden, { smDown: true },
                    react_1.default.createElement(searchbar_1.default, { handleInputChange: this.handleInputSearch, className: 'mb-20', style: { top: '10px' } })) : null,
                itemsCount || !firstData ?
                    react_1.default.createElement(core_1.Box, { className: 'sub-heading' },
                        react_1.default.createElement("div", { className: `pdf-icon ${common_1.ifMobile() ? 'visibility-hidden' : ''}`, onClick: userHistorySlice_1.downloadFile(filter) },
                            react_1.default.createElement("div", { className: 'download-icon' }),
                            react_1.default.createElement(core_1.Hidden, { smDown: true }, "Download PDF"),
                            react_1.default.createElement(core_1.Hidden, { mdUp: true }, "PDF")),
                        react_1.default.createElement("div", { className: "total-money-info" },
                            react_1.default.createElement(core_1.Hidden, { smDown: true },
                                react_1.default.createElement("p", { className: 'earned' },
                                    "Total Earned: ",
                                    react_1.default.createElement("strong", null,
                                        "$",
                                        totalEarned)),
                                react_1.default.createElement("p", null,
                                    "Total Paid: ",
                                    react_1.default.createElement("strong", null,
                                        "$",
                                        totalPaid))),
                            react_1.default.createElement(core_1.Hidden, { mdUp: true },
                                react_1.default.createElement("div", { className: 'titles-mobile-wrapper' },
                                    react_1.default.createElement("p", null, "Total Earned:"),
                                    react_1.default.createElement("p", null, "Total Paid:")),
                                react_1.default.createElement("div", { className: 'text-mobile-wrapper' },
                                    react_1.default.createElement("p", null,
                                        "$",
                                        totalEarned),
                                    react_1.default.createElement("p", null,
                                        "$",
                                        totalPaid))))) : null,
                react_1.default.createElement("div", { id: 'user-history-content-wrapper', className: "content-wrapper" },
                    itemsCount || !this.state.firstData ?
                        react_1.default.createElement(core_1.Box, { id: 'filter-container', className: `filter-container ${this.state.filterOpen ? 'visible' : ''}` },
                            react_1.default.createElement("div", { className: "heading" },
                                react_1.default.createElement("h4", null, "Filter"),
                                react_1.default.createElement("p", { onClick: this.props.resetFilter }, "Clear")),
                            react_1.default.createElement("div", { className: 'filters-wrapper' },
                                react_1.default.createElement(filterBlock_1.default, { title: 'Date Range' },
                                    react_1.default.createElement(rangePicker_1.default, { handleDateChange: this.handleRangeChange, filterReseted: filterReseted, rangeDates: { from: filter.date_from, to: filter.date_to } })),
                                react_1.default.createElement(filterBlock_1.default, { title: 'Request Was' },
                                    react_1.default.createElement("div", { className: 'btns-wrapper' },
                                        react_1.default.createElement(core_1.Button, { onClick: (e) => this.handleFilterClick(e, 'created'), className: `v2-btn created ${filter.request_was === 'created' ? 'v2-btn-secondary' : 'v2-btn-primitive'}`, disableRipple: true }, "Created"),
                                        react_1.default.createElement(core_1.Button, { onClick: (e) => this.handleFilterClick(e, 'accepted'), className: `v2-btn ${filter.request_was === 'accepted' ? 'v2-btn-secondary' : 'v2-btn-primitive'}`, disableRipple: true }, "Accepted"))),
                                react_1.default.createElement(filterBlock_1.default, { title: 'Request Type' },
                                    react_1.default.createElement(checkboxList_1.default, { data: config_1.requestTypes, handleChangeEvent: this.handleFilterChange, filterData: filter, filterType: 'request_types' })),
                                react_1.default.createElement(filterBlock_1.default, { title: 'Payment Status' },
                                    react_1.default.createElement(radioButtonsList_1.default, { handleChangeEvent: this.handleRadioListChange, filterType: 'payment_statuses', filterData: filter.payment_statuses, data: config_1.paymentStatuses }))),
                            react_1.default.createElement(core_1.Hidden, { mdUp: true },
                                react_1.default.createElement("div", { className: "filter-btns-wrapper" },
                                    react_1.default.createElement(core_1.Button, { onClick: this.toggleMobileFilter, variant: "contained", color: "primary", disableRipple: true, className: "v2-btn v2-btn-primary" }, "Save"),
                                    react_1.default.createElement(core_1.Button, { onClick: () => {
                                            this.props.resetFilter();
                                            this.toggleMobileFilter();
                                        }, disableRipple: true, variant: "contained", className: "v2-btn v2-btn-tertiary" }, "Skip")))) : null,
                    react_1.default.createElement(core_1.Box, { id: 'data-container', className: 'data-container' },
                        list.length > 0 ? react_1.default.createElement("div", null,
                            list.map((el, i) => {
                                return react_1.default.createElement(item_case_1.default, { key: i, data: el });
                            }),
                            react_1.default.createElement(ajaxLoader_1.default, null)) : null,
                        itemsCount > filter.limit && list.length > 0 ? react_1.default.createElement(pagination_1.default, { changeParams: filter, resetConditions: [filter.request_was, filter.date_from, filter.q, filter.request_types, filter.payment_statuses], changeRequest: this.props.getUserHistory, itemsCount: itemsCount, removeMutatedBlock: () => {
                                if (document.getElementById('user-history-temp-filter')) {
                                    this.putBackDirectoryFilter();
                                    this.toggleMobileFilter();
                                }
                            }, browserHistoryHandle: () => {
                                this.props.getUserHistory(Object.assign(Object.assign({}, filter), { offset: parseInt(common_1.urlPrams("page")) - 1 || 0 }));
                            } }) : null,
                        !itemsCount || !list.length ?
                            react_1.default.createElement("div", { className: 'vh-100 no-result' },
                                react_1.default.createElement(ajaxLoader_1.default, null),
                                showIcon ? mounted && react_1.default.createElement(noResult_1.default, null) : react_1.default.createElement(noResult_2.default, null)) : null))),
            caseDetails.requestIs && react_1.default.createElement(caseDetails_1.default, { toggleModal: this.handleModalChange })));
    }
}
const mapStateToProps = (state) => {
    const { userHistory } = state;
    return {
        userHistory,
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getUserHistory: (data) => dispatch(userHistorySlice_1.getUserHistory(data)),
        toggleDetailsModal: () => dispatch(userHistorySlice_1.toggleDetailsModal()),
        updateHistoryList: (data) => dispatch(userHistorySlice_1.updateHistoryList(data)),
        resetFilter: () => dispatch(userHistorySlice_1.resetFilter())
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(App);
